import { CheckValue } from "../Service/service";

/**
 * Converts form values into URLSearchParams format.
 * - Strings and arrays are handled properly
 * - Empty or invalid values are removed from the params
 */
export const encodeParamsFromValues = (values, currentParams) => {
  const newParams = new URLSearchParams(currentParams.toString());

  for (const [key, val] of Object.entries(values)) {
    const isValidString = typeof val === "string" && val.trim() !== "";
    const isValidNumber = typeof val === "number" && !isNaN(val);
    const isValidArray = Array.isArray(val) && val.length > 0;

    if (CheckValue(val) && (isValidString || isValidArray || isValidNumber)) {
      newParams.set(key, isValidArray ? val.join(",") : val);
    } else {
      newParams.delete(key);
    }
  }

  return newParams;
};

/**
 * Converts URLSearchParams into an object to initialize form fields.
 * Automatically splits comma-separated strings into arrays.
 */
export const decodeParamsToValues = (params, defaultFilter = []) => {
  const values = {};

  defaultFilter.forEach(({ keyName, value: keyValue, type }) => {
    const value = params.get(keyName);

    if (value && (value.includes(",") || type === 'array')) {
      values[keyName] = value.split(",").map((v) => v.trim());
    } else if (value !== null) {
      values[keyName] = value;
    } else if (!!keyValue) {
      values[keyName] = keyValue;
    }
  });

  return values;
};
